module.exports = __webpack_public_path__ + "img/indexMaskBg.1a05ec3c.png";